import React from 'react';
import About from './about';

function Home() {
  return (
    <div class="min-h-screen mx-auto flex flex-col text-black">
      <div class=" flex flex-auto justify-center pt-40 mt-20 sm:-mt-2 sm:pt-0 space-x-10 sm:flex-col">
        <div class="sm:place-self-center">
          <img
            class="rounded-2xl h-28 w-28 sm:rounded-full"
            src={process.env.PUBLIC_URL + '/image/Profile.jpg'}
            alt="profilePicture"
          />
        </div>
        <div class="sm:text-center sm:place-self-center sm:mt-10 sm:pr-4" >
          <div class="text-5xl sm:text-4xl "><h1>Hi!</h1></div>
          <div><h2 class="text-3xl md:text-3xl sm:text-sm">I am Nidhi</h2></div>
          <p class="text-gray-400 sm:text-xs">Front End Developer</p>
     
        </div>
      </div>
      <div class="flex justify-center py-20">
      <About />
      </div>
    </div>
  );
}

export default Home;
